// extracted by mini-css-extract-plugin
export var dividerLine = "_89-3";
export var itemImage = "_89-9";
export var lightDivider = "_89-4";
export var modalContent = "_89-5";
export var modalContentCompact = "_89-6";
export var productCard = "_89-a";
export var productImage = "_89-b";
export var productImageCompact = "_89-7";
export var productImagePlaceholder = "_89-c";
export var productImagePlaceholderCompact = "_89-8";
export var progressBarBackground = "_89-1";
export var progressBarContainer = "_89-0";
export var progressBarFill = "_89-2";